import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

module.exports = {
  QualificationsTable: ({data, geo, geo_aggregation}) => <div>Table</div>,
  EducationTable: ({data, geo, geo_aggregation}) => <div>Table</div>,
  "Family Composition": ({ data, geo, geo_aggregation }) => <div>Table</div>,
  "Children in Family": ({
    data,
    geo,
    geo_aggregation
  }) => <div>Table</div>,
  "Residents in Dwelling": ({ data, geo, geo_aggregation }) => <div>Table</div>,
  "Household Income": ({ data, geo, geo_aggregation }) => <div>Table</div>,
  "Internet Access": ({ data, geo, geo_aggregation }) => <div>Table</div>,
  "Socioeconomic disadvantage (SEIFA)": ({ data, geo, geo_aggregation }) => (
    <div>Table</div>
  )
}



// WEBPACK FOOTER //
// ./components/Tables/SocioEconomicCharacteristics.js